import request from "@/utils/request";

export default function agentUnBindAccessControlDevice(params) {
    return request.post(`/device/accessControllerDevice/agentUnBindAccessControlDevice`, null,
        {
            params
        }
    )
}
